/** 行程编辑快速模板；服务标准使用当前业务版本，注意事项保留迁移原文。 */
export const LEGACY_SERVICE_STANDARD_TEMPLATE_NAME = "通用";
export const LEGACY_SERVICE_STANDARD_TEMPLATE = {
  "transport": [
    "1、交通：D2华东上海起D9浙江杭州止旅游大巴车用车服务，根据人数安排最优车型，保证每人一正座。"
  ],
  "stay": [
    "2、住宿： 含当地住宿X晚，标准双人间（或大床），如有单男或单女情况则根据酒店房型安排三人间。"
  ],
  "meal": [
    "3、餐饮：全程仅包含X个早餐，早餐为住宿点赠送。"
  ],
  "ticket": [
    "4、门票：全程不包含考察课程中所列考察景点学生优惠门票，参考如下：XXX。以上学生优惠门票需出示有效的学生证原件购买，若因未携带有效的学生证，购票时产生的差价请自理。\n注：学生优惠门票指全日制大学本科及以下学历学生凭本人学生证原件购买优惠门票；研究生不能享受各景区学生票优惠政策，只能购买成人全价票。"
  ],
  "insurance": [
    "5、保险：含旅行社1000万责任险，赠送旅游人身意外伤害保险，保额XX万/人。"
  ],
  "guide": [
    "6、领队：D1上海起D9杭州止一名优秀领队提供服务。"
  ],
  "excluded": [
    "7、不含项目：不含全程门票、不含学院至四平火车站或机场往返接送用车服务；不含全程正餐以及服务标准中一切未提及项目。"
  ],
  "intangible_heritage": [
    "8、非遗考察：包含XXX考察交流及体验。"
  ],
  "agency_payment": [
    "9、代收代付火车票 : 代订西安-乌鲁木齐单程火车硬卧二等卧或硬座；代订喀什-西安单程火车硬卧二等卧或硬座；票款代收后将直接支付给票务公司深圳市票管家网络科技有限公司，票款明细：西安-乌鲁木齐单程火车硬卧二等卧467.5元/人x168人=78540元，喀什-西安单程火车硬卧二等卧621元/人x168人=104328元；票款暂按硬卧中铺收取，往返票款预估182868元，最终票款金额以实际出票金额为准。"
  ],
  "enterprise_visit": [
    "10、企业单位：考察课程中所涉及到的部分考察企业（或单位、学院等）接待/考察/交流仅为友好合作。企业/学校/学院并非旅游景点，具备一定的变动可能性。故行程中所包含的公司、企业、工作室以及学院等需至少提前15-30天预约，并在考察日前一周内再次确认，计划考察的企业/学校/学院及时间安排请以最终确认为准。"
  ],
  "other": [
    "11、其他说明：部分考察点（如博物馆、美术馆、寺庙等）为事业或文保单位（不以盈利为目的），未对社会公众提供团队预约端口，需自行在规定时间内前往其微信公众号进行个人参观预约，如博物馆、上海美术馆等。"
  ]
} as const;

export const LEGACY_NOTICE_TEMPLATE_NAMES = [
  "宏村",
  "婺源",
  "贵州",
  "江西",
  "广西",
  "广深",
  "云南",
  "川西",
  "川渝",
  "陕西",
  "西北",
  "华东",
  "甘肃",
  "青海",
  "山西",
  "河南",
  "福建",
  "北京",
  "湖南",
  "湘西",
  "新疆",
  "山东",
  "安徽",
  "通用"
] as const;
export const LEGACY_NOTICE_TEMPLATES: Record<string, readonly string[]> = {
  "宏村": [
    "1、写生基地主要接待学生,以客栈住宿标准为主,所以床是上下铺标准",
    "2、写生期间包含了写生基地的用餐,普通餐标,同学们可以自费提高餐标",
    "3. 宏村离黄山较近,可在写生期间选一天自费前往黄山,第二天返回宏村",
    "4. 导游全程不引导购物，如遇导游引导购物请立即向花儿举报；大家自行选购旅游纪念商品、当地土特产时，请注意货比三家；同时注意不要随意去动摆设的样品，以防意外损坏",
    "5. 行程结束后30日内，甲方可以提供开票信息给乙方，乙方将按照实际提供的服务内容、适用税率、合同金额（不包含代收代付的旅游费用）开具电子普通发票给甲方。",
    "6. 甲方委托乙方代收并代付给第三方的旅游费用，由实际收款的第三方开具发票给甲方，乙方不承担开票义务。"
  ],
  "婺源": [
    "写生基地主要接待学生,以客栈住宿标准为主,所以床是上下铺标准",
    "2、写生期间包含了写生基地的用餐,普通餐标,同学们可以自费提高餐标",
    "3. 导游全程不引导购物，如遇导游引导购物请立即向花儿举报；大家自行选购旅游纪念商品、当地土特产时，请注意货比三家；同时注意不要随意去动摆设的样品，以防意外损坏",
    "4. 行程结束后30日内，甲方可以提供开票信息给乙方，乙方将按照实际提供的服务内容、适用税率、合同金额（不包含代收代付的旅游费用）开具电子普通发票给甲方。",
    "5. 甲方委托乙方代收并代付给第三方的旅游费用，由实际收款的第三方开具发票给甲方，乙方不承担开票义务。"
  ],
  "贵州": [
    " 1、贵州气候多变，雨水较多，请携带雨伞和防水鞋类。",
    "2、贵州多山区，气候潮湿，早晚凉爽，洗衣不易干。请准备足量衣物，适合行走的运动鞋，身边随时备一件外套。夏秋季节蚊虫较多，自备驱蚊药水。",
    "3、贵州饮食以酸、辣为主要特色，有食用生冷食物的习俗，建议大家根据自身体质状况和饮食习惯选择用餐，不适应的食物尽量少吃。可自备少量肠胃药和感冒药。",
    "4、贵州少数民族众多，考察学习期间注意尊重当地的民族传统习俗和生活中的禁忌，以免造成不良后果。拍照等活动注意征得拍摄对象同意。",
    "5、贵州少数民族村寨以木楼为主，隔音不佳，防火第一。夜间请注意不要在房间喧闹，以免影响他人休息。上下楼梯注意安全。",
    "6、贵州少数民族普遍有饮酒习俗，大家饮酒应注意适可而止，如不饮酒，用餐时提前说明。",
    "7、入住客栈或酒店时，请进入房间后，先查看一下房间情况，有卫生等问题及时向导游提出，方便及时处理。",
    "8、行程结束后30日内，甲方可以提供开票信息给乙方，乙方将按照实际提供的服务内容、适用税率、合同金额（不包含代收代付的旅游费用）开具电子普通发票给甲方。",
    "9、甲方委托乙方代收并代付给第三方的旅游费用，由实际收款的第三方开具发票给甲方，乙方不承担开票义务。"
  ],
  "江西": [
    " 1、江西多山区，请穿着舒适的运动鞋，忌穿皮鞋等有根儿的鞋，以防止滑倒",
    "2、江西气候湿润，口味偏重偏辣，主食以米饭为主",
    ";3、江西每年降雨充分，湿度较大，早晚温差大，请您带上合适的衣、带好雨伞",
    "4、当地由于是山区,多弯路,要常备晕车药品；早晚较凉,要备外套",
    "5、 导游全程不引导购物，如遇导游引导购物请立即向花儿举报；大家自行选购旅游纪念商品、当地土特产时，请注意货比三家；同时注意不要随意去动摆设的样品，以防意外损坏",
    "6、 行程结束后30日内，甲方可以提供开票信息给乙方，乙方将按照实际提供的服务内容、适用税率、合同金额（不包含代收代付的旅游费用）开具电子普通发票给甲方。",
    "7、 甲方委托乙方代收并代付给第三方的旅游费用，由实际收款的第三方开具发票给甲方，乙方不承担开票义务。"
  ],
  "广西": [
    "1、广西地处亚热带，气候温暖，全年大部分时间气温在20度以上，衣物携带以凉爽舒适为主。",
    "2、建议自备个人卫生用品，保湿防晒，广西沿海地区日照强烈，可根据自身需要携带遮阳伞、遮阳帽、墨镜等用品。",
    "3、广西地区热带水果众多，海鲜产品丰富，价格亲民，大家购买食用时要注意个人身体情况，合理适量，避免产生严重过敏、腹泻、上火等症状。日常用餐注意选择干净卫生的餐馆，不食用隔夜的食物。",
    "4、沿海区域或海岛考察，注意安全，不前往陌生海滩、岛礁、溶洞、崖壁等地游览，观海拍照注意安全，沙滩踩水需前往景区标示安全区域。夜间不前往海滩，不随当地渔民出海。",
    "5、前往涠洲岛等岛屿写生需乘坐海轮，有晕车晕船情况同学提前准备药品，上船后按规定就坐，遇风浪较大时，不可前往船舱外观景。",
    "6、随身携带身份证、学生证，方便取用。博物馆和景区均为实名制刷生份证入园，高铁、轮船及酒店住宿也需当场出示身份证。",
    "7、前往少数民族村寨或聚居区考察，注意尊重当地民族习俗，包容和欣赏民俗文化传统，礼貌探访。",
    "8、部分乡村可能蚊虫较多，建议自备花露水或驱蚊药水等用品。村落中不要逗弄猫狗，谨防抓伤。",
    "9、夜间按时返回住宿点，住宿酒店客栈不高声喧哗，注意爱护清洁卫生，有问题及时沟通。",
    "10、行程结束后30日内，甲方可以提供开票信息给乙方，乙方将按照实际提供的服务内容、适用税率、合同金额（不包含代收代付的旅游费用）开具电子普通发票给甲方。",
    "11、甲方委托乙方代收并代付给第三方的旅游费用，由实际收款的第三方开具发票给甲方，乙方不承担开票义务。"
  ],
  "广深": [
    "1、请随身携带各类证件（身份证、学生证）！",
    "2、广深地区以海洋季风气候为主，比较湿热，日照较强烈。注意携带合适衣物，遮阳伞、遮阳帽、墨镜等物品。",
    "3、广深地区饮食文化丰富，大量美食值得尝试，大家用餐前注意问清价格，注意卫生，尽量不前往三无小店。由于气温较高，食物变质快，隔夜食品不要食用。不要贪凉，糖水（凉茶）饮用适度。",
    "4、广深地区地处沿海，社会情况相对复杂，大家注意识别各类诈骗、反动、赌博等犯罪行为，不要相信天上会掉馅饼，远离是非之地。",
    "5、广深企业考察期间，遵守企业规定，保持良好参观考察秩序，珍惜学习机会，不泄露企业商业机密，离别时给予礼貌性感谢。",
    "6、考察期间严格按照规定时间返回酒店，不得私自前往行程外目的地，自由考察期间结伴行动，注意安全。",
    "7、行程结束后30日内，甲方可以提供开票信息给乙方，乙方将按照实际提供的服务内容、适用税率、合同金额（不包含代收代付的旅游费用）开具电子普通发票给甲方。",
    "8、甲方委托乙方代收并代付给第三方的旅游费用，由实际收款的第三方开具发票给甲方，乙方不承担开票义务。"
  ],
  "云南": [
    "必备证件：持有效期内身份证、学生证（身份证件随身携带、入住和门票需要），不要放行李箱中。",
    " 2、云南地处高原早晚温差大，紫外线强，注意携带防晒用品。",
    "3、云南部分区域洗漱用品单一，建议自备个人卫生用品。",
    "4、常用感冒药、晕车药、肠胃药，蚊虫叮咬止痒药等建议自备。",
    "5、部分行程考察点之间路程相对较远，可提前准备随一些小零食，以备不时之需。",
    "6、云南饮食文化丰富，要根据自身情况合理选择，确保不影响身体健康和行程。（当地特色饮食汽锅鸡、云南火腿、过桥米线、饵块饵丝、鲜花饼、喜洲粑粑、野生菌火锅、野菜，洱海鱼等等）尽量不食用生食。",
    "7、云南少数民族众多，考察中请尊重民俗习惯，接纳民族礼节，入乡随俗。拍照务必征得同意。",
    "8、行程结束后30日内，甲方可以提供开票信息给乙方，乙方将按照实际提供的服务内容、适用税率、合同金额（不包含代收代付的旅游费用）开具电子普通发票给甲方。",
    "9、甲方委托乙方代收并代付给第三方的旅游费用，由实际收款的第三方开具发票给甲方，乙方不承担开票义务。"
  ],
  "川西": [
    " 1、四川饮食口味偏重偏辣,主食以米饭为主，用餐注意根据个人习惯调整，切忌带病进入川西。",
    "2、川西高原早晚温差较大,请注意准备衣物,预防感冒。建议进入川西，必备一件带抓绒冲锋衣或羽绒服，应对气温突变和高海拔降温。高原地区的紫外线强烈，秋冬气候干燥，防晒霜、保湿护肤品和遮阳伞墨镜等为常备物品。",
    "3、少数民族饮食与汉族有一定差异，尽量不食用生冷食物，进入高原后少饮酒，不喝生水，建议自备保温杯，多喝热水。",
    "4、进入川西后海拔迅速升高，初次进高原会有一定身体不适，适应后会缓解。第一天建议尽量不洗澡不洗头，晚上有条件可热水泡脚。洗澡或洗发后务必在房间内把头发吹干。",
    "5、高原地区天气变化快，出现感冒等症状后购药不便，建议自备部分常用感冒药、止疼药和肠胃药，以及邦迪、云南白药等外伤药。预防高原反应用品：复合维生素、丹参、肌苷、红景天。有身体不适一定要第一时间告诉老师和导游，寻求解决办法。",
    "6、川西地区路况变化快，容易发生堵车，必须自备部分方便食品。登山等活动时，可携带巧克力、士力架、牛肉干等高热量食品迅速补充能量。",
    "7、川西地区大部分属于藏羌民族，他们独特的文化习俗和生活习惯，考察期间可以很好的了解他们的文化历史，同时也要尊重他们的生活习惯。部分偏远地区，民风淳朴彪悍，性情刚烈，且有特殊的民族习俗禁忌，导游讲解时请仔细收听，游览时注意避讳。",
    "8、考察过程中全程集体活动，不可私自前往未开发或行程以外区域！",
    "9、有身体不适或其他原因无法参加当日考察活动的，请及时向带队老师请假报备。入住客栈或酒店后，夜间尽量不外出。",
    "10、高原地区天气变化快，出现感冒等10、高原地区由于地理位置缘故，物价高选择少，选购物品确定需要再还价，确定价格后就必须购买，不想购买就不要讨价还价。",
    "11、行程结束后30日内，甲方可以提供开票信息给乙方，乙方将按照实际提供的服务内容、适用税率、合同金额（不包含代收代付的旅游费用）开具电子普通发票给甲方。",
    "12、甲方委托乙方代收并代付给第三方的旅游费用，由实际收款的第三方开具发票给甲方，乙方不承担开票义务。"
  ],
  "川渝": [
    " 1、川渝地区气候湿润，夏季炎热，冬季湿冷，气温波动较大，常有夜雨，请携带适当衣物、鞋类及晴雨伞等个人物品。",
    "2、川渝地区（特别是重庆），受地形限制公路比较狭窄，坡大湾急道路情况复杂，大部分地区大巴停车困难，上下车集合请务必准时，听从安排。有晕车情况的同学，请提前准备晕车药。",
    "3、川渝饮食重油重辣但内容丰富，火锅麻辣鲜香但多吃易上火，大家在选择时务必根据自己情况，麻辣与清淡合理搭配。建议初到川渝，火锅选择微辣即可。",
    "4、川渝及周边地区，物价相对较低，购物消费时请先问清价格，景区及周边物价往往较高。",
    "5、行程结束后30日内，甲方可以提供开票信息给乙方，乙方将按照实际提供的服务内容、适用税率、合同金额（不包含代收代付的旅游费用）开具电子普通发票给甲方。",
    "5、甲方委托乙方代收并代付给第三方的旅游费用，由实际收款的第三方开具发票给甲方，乙方不承担开票义务。"
  ],
  "陕西": [
    "1、陕西地处关中，四季分明多晴少雨，冬春风沙较大，出行前根据气温携带合适衣服、鞋帽。",
    "2、建议自备个人卫生用品，保湿防晒，陕西气候干燥，多喝水多吃蔬菜水果，饮食不宜过辣。",
    "3、饮食以面食为主，也有米饭，牛羊肉较多，物价水平不高。注意不可带猪肉制品及酒类进入清真餐厅。",
    "4、西安13朝古都，历史文物古迹众多，参观考察时请遵守景区场馆规定，文明参观，室外文物切忌乱涂乱画！",
    "5、尊重少数民族习俗，当地伊斯兰教回民较多，饮食忌猪肉，忌浪费食物，拿食物开玩笑。进入清真寺等宗教场所参观拍照需征得同意，准守规定。在进行宗教仪式时切勿打扰。",
    "6、博物馆参观注意合理安排时间，提前关注微信公众号，预约门票及讲解。",
    "7、景区购买纪念品等注意货比三家，警惕购物陷阱。购买土特产等尽量前往正规超市选购。",
    "8、行程结束后30日内，甲方可以提供开票信息给乙方，乙方将按照实际提供的服务内容、适用税率、合同金额（不包含代收代付的旅游费用）开具电子普通发票给甲方。",
    "9、甲方委托乙方代收并代付给第三方的旅游费用，由实际收款的第三方开具发票给甲方，乙方不承担开票义务。"
  ],
  "西北": [
    "1、西北考察学习路途远、时间长，出发前请尽量对考察行程预做了解。",
    "2、西北地区气候干燥，风沙较大，日照强烈，昼夜温差大。请选带合适衣服、鞋帽、围巾、遮阳伞及墨镜等用品。四五月与九十月都有可能出现极端天气，建议带厚衣服一件。",
    "3、请自备个人洗漱用品，防晒、保湿很重要。可自备适当常用药品（感冒药、肠胃药、外伤用药）。注意：超过100ml喷雾不能带上火车。",
    "4、饮食以面食为主，也有米饭，牛羊肉较多，物价水平相对较高。进入西北地区，蔬菜较少，多食用水果。注意不可带猪肉制品及酒类进入清真餐厅。",
    "5、尊重少数民族习俗，西北沿线伊斯兰教回民较多，饮食忌猪肉，忌浪费食物，忌拿食物开玩笑。进入清真寺等宗教场所参观拍照需征得同意，准守规定。在进行宗教仪式时切勿打扰。",
    "6、西北地区考察，大巴车时间较长，有晕车情况的同学要提前自备晕车药，路上服务区较少，可自备部分零食。",
    "7、西北地区考察，石窟壁画较多，由于洞内光线较暗，建议可以自备强光手电一支。",
    "8、戈壁滩手机信号不好，前往鸣沙山、魔鬼城等景点考察，切不可进入未开发区域，防止走失。",
    "9、戈壁行车，前排乘客注意观察大巴师傅精神状态，提醒师傅合理休息。",
    "10、行程结束后30日内，甲方可以提供开票信息给乙方，乙方将按照实际提供的服务内容、适用税率、合同金额（不包含代收代付的旅游费用）开具电子普通发票给甲方。",
    "11、甲方委托乙方代收并代付给第三方的旅游费用，由实际收款的第三方开具发票给甲方，乙方不承担开票义务。"
  ],
  "华东": [
    "1、华东考察博物馆和展览馆参观较多，景区全部为实名制刷身份证进入，身份证和学生证务必每天随身携带！博物馆和展览馆请提前两天关注公众号，了解最新资讯和布展情况。",
    "2、华东地区春秋两季天气变化快，气温波动较大，携带衣物时注意厚薄均匀搭配，晴雨适用。",
    "3、华东考察交通以大巴为主，城区考察点停车不便，需要大家积极配合导游安排，按时到达指定上车位置，快速上下车。",
    "4、华东区域饮食相对清淡，江浙一带口味偏甜鲜，少辛辣。景区及商业繁华地域消费水平较高，普通餐饮店价格适中。",
    "5、华东区域考察，商业、科技公司交流较多，请大家珍惜进入公司考察学习机会，遵守公司规定，室内场合保持安静，做到有礼有节。",
    "6、华东区域大城市住宿距离城市中心区域有一定距离，早晚高峰期交通比较拥堵，大家要合理规划时间。",
    "7、水乡古镇写生期间，注意安全，不下河捞鱼戏水，夜间不临河游览创作。",
    "8、大城市中骑行电动助力车等交通工具，务必注意安全，准守交通规则，控制速度。",
    "9、晚间按时返回酒店，不前往与考察学习无关娱乐场所。",
    "10、行程结束后30日内，甲方可以提供开票信息给乙方，乙方将按照实际提供的服务内容、适用税率、合同金额（不包含代收代付的旅游费用）开具电子普通发票给甲方。",
    "11、甲方委托乙方代收并代付给第三方的旅游费用，由实际收款的第三方开具发票给甲方，乙方不承担开票义务。"
  ],
  "甘肃": [
    "1、甘肃属大陆干旱性气候，早晚温差较大，请注意着装，预防感冒",
    "2、甘肃地处西北，气候干燥，且灰尘较大，注意每天补充适量水分，多喝水多吃水果",
    "3、甘肃饮食为北方口味，多牛羊肉，主食以面食为主",
    "4、甘肃为回民集聚地，应尊重当地的民族传统习俗和生活中的禁忌,以免造成不良后果",
    "5、敦煌莫高窟洞窟较黑，参观时需备手电简；禁止带摄相机及相机入内，可在入口处寄存",
    "6、登鸣沙山滑沙时，最好不要随身携带照相机，以免沙子进入相机损坏或丢失",
    "7、 导游全程不引导购物，如遇导游引导购物请立即向花儿举报；大家自行选购旅游纪念商品、当地土特产时，请注意货比三家；同时注意不要随意去动摆设的样品，以防意外损坏",
    "8、 行程结束后30日内，甲方可以提供开票信息给乙方，乙方将按照实际提供的服务内容、适用税率、合同金额（不包含代收代付的旅游费用）开具电子普通发票给甲方。",
    "9、 甲方委托乙方代收并代付给第三方的旅游费用，由实际收款的第三方开具发票给甲方，乙方不承担开票义务。"
  ],
  "青海": [
    " 1、青海地处青藏高原，不要走太快，否则会有缺氧的感觉。如感到缺氧，多做深呼吸",
    "2、青海大陆干旱性气候早晚温差较大，请注意着装，预防感冒",
    "3、青海饮食为北方口味，多牛羊肉，主食以面食为主",
    "4、青海为藏族、回族集聚地，应尊重当地的民族传统习俗和生活中的禁忌,以免造成不良后果",
    "5、 导游全程不引导购物，如遇导游引导购物请立即向花儿举报；大家自行选购旅游纪念商品、当地土特产时，请注意货比三家；同时注意不要随意去动摆设的样品，以防意外损坏",
    "6、 行程结束后30日内，甲方可以提供开票信息给乙方，乙方将按照实际提供的服务内容、适用税率、合同金额（不包含代收代付的旅游费用）开具电子普通发票给甲方。",
    "7、 甲方委托乙方代收并代付给第三方的旅游费用，由实际收款的第三方开具发票给甲方，乙方不承担开票义务。"
  ],
  "山西": [
    "1、山西气候干燥少雨，夏季日照强烈，冬季山区气温极寒，昼夜温差较大，需携带合适衣物。部分区域步行时间较长，请准备合适鞋类。",
    "2、山西饮食以面食为主，口味清淡，饮食品类较少。部分地区水质较硬，建议购买瓶装水饮用。",
    "3、山西部分考察点地域较偏，附近餐饮较少，有时不能按时用餐。建议身边自带适量零食。",
    "4、山西古建寺庙众多，考察期间一定要注意遵守景区规定，文明参观，古建文物杜绝一切用火，切忌乱涂乱画。",
    "5、尊重宗教习俗，不打扰寺庙内佛事活动，不听信寺庙外算命求签等活动。",
    "6、考察期间请随身携带身份证、学生证，方便景区取票，住宿登记及路上检查用。",
    "7、贵重物品随身携带，更换酒店时务必反复检查确认个人物品已全部收拾带走。",
    "8、有会见亲友，身体不适，无法参加当天考察等情况，请及时向带队老师请假报备。晚间按时返回住宿酒店。",
    "9、行程结束后30日内，甲方可以提供开票信息给乙方，乙方将按照实际提供的服务内容、适用税率、合同金额（不包含代收代付的旅游费用）开具电子普通发票给甲方。",
    "10、甲方委托乙方代收并代付给第三方的旅游费用，由实际收款的第三方开具发票给甲方，乙方不承担开票义务。"
  ],
  "河南": [
    "1、景区全部为实名制刷身份证进入，身份证和学生证务必每天随身携带！部分遗址类场馆禁止闪光灯拍摄，参观时勿触碰文物展品",
    "2、 河南属温带季风气候，四季分明，春秋季昼夜温差大，备足防风外套与保暖衣物；夏季高温，携带防晒用品与防暑药品；冬季寒冷干燥，需厚棉衣、围巾等御寒装",
    "3、 行程以大巴为主，部分山区道路曲折，晕车者备好药品，乘车全程系安全带",
    "4、 豫菜口味适中，烩面、胡辣汤、道口烧鸡等特色鲜明。部分地区饮食偏辛辣油腻，肠胃敏感者注意搭配",
    "5、 参观历史文化遗址，应着装庄重，不随意攀爬古迹、触碰展品",
    "6、 企业考察时，请大家珍惜进入公司考察学习机会，遵守公司规定，室内场合保持安静，做到有礼有节",
    "7、 晚间外出需2人以上结伴并报备带队老师；不前往与考察学习无关的娱乐场所",
    "8、 大城市中骑行电动助力车等交通工具，务必注意安全，遵守交通规则，控制速度",
    "9、 行程结束后30日内，甲方可以提供开票信息给乙方，乙方将按照实际提供的服务内容、适用税率、合同金额（不包含代收代付的旅游费用）开具电子普通发票给甲方",
    "10、 甲方委托乙方代收并代付给第三方的旅游费用，由实际收款的第三方开具发票给甲方，乙方不承担开票义务"
  ],
  "福建": [
    " 1、福建地区属亚热带季风气候，白天气温较高，日照强烈，请根据气温情况，携带适当衣物，遮阳伞、遮阳帽、墨镜等物品。",
    "2、个人卫生用品，防晒、保湿用品建议自备。福建山区（考察土楼等）蚊虫较多，可提前准备驱蚊药水。",
    "3、福建沿海地区，饮食清淡，喜食海鲜，各类虾蟹贝类产品丰富，有海鲜类过敏史的同学要注意。喜欢麻辣的同学可自备辣酱或者咸菜。食用海鲜类产品时，注意是否新鲜未变质。",
    "4、临海景区考察时，注意安全，不下海游泳，不私自乘船出海，不前往礁石、崖壁、溶洞等危险区域，拍照务必注意安全。",
    "5、考察鼓浪屿、湄洲岛等岛屿时，上岛需乘船，乘船注意安全。岛上面积较大，全岛需步行，注意多看指示路标。",
    "6、福建地区方言较多，闽南话为主，方言各异很大，请尊重当地习俗，注意言辞。",
    "7、福建人喜好饮茶，讲究风水，路边神龛切记触碰，讲究拜佛随喜。",
    "8、行程结束后30日内，甲方可以提供开票信息给乙方，乙方将按照实际提供的服务内容、适用税率、合同金额（不包含代收代付的旅游费用）开具电子普通发票给甲方。",
    "9、甲方委托乙方代收并代付给第三方的旅游费用，由实际收款的第三方开具发票给甲方，乙方不承担开票义务。"
  ],
  "北京": [
    "1、行程中各种证件随身携带（身份证、学生证）！",
    "2、严格准时，通知的游览时间和集合地点要牢记，不得私自脱团。",
    "3、参观各类场馆、古建要严格遵守参观要求，文明出行，注意礼让。",
    "4、注意个人着装，保持集体形象，不拍摄发布有违社会公德、法律法规的图片和视频。",
    "5、北京地区气候干燥，春秋季风大有沙尘，注意携带合适衣物，多喝热水。",
    "6、北京市内考察，交通容易拥堵，有晕车情况的同学请提前准备晕车药。",
    "7、北京餐饮方便，饮食融合全国各地口味，用餐注意卫生，问清价格。",
    "8、行程结束后30日内，甲方可以提供开票信息给乙方，乙方将按照实际提供的服务内容、适用税率、合同金额（不包含代收代付的旅游费用）开具电子普通发票给甲方。",
    "9、甲方委托乙方代收并代付给第三方的旅游费用，由实际收款的第三方开具发票给甲方，乙方不承担开票义务。"
  ],
  "湖南": [
    " 1、湖南气候独特，山区湿润多雨多雾，峡谷平坝日照较强，气候变化较快。建议携带方便合适衣物方便随时添减，防水防滑适合步行鞋类，必备晴雨伞。",
    "2、湖南山区较多，山路坡度弯度较大，有晕车情况的同学请提前准备晕车药或晕车贴，早餐尽量清淡不易过饱。",
    "3、湖南地区饮食独特，餐饮中有很多独有野生佐料，用餐时请谨慎尝试。苗族土家族有以酒迎客习俗，自制白酒后劲大，一定要注意。",
    "4、导游全程不引导购物，如遇导游引导购物请立即向花儿举报；大家自行选购旅游纪念商品、当地土特产时，请注意货比三家；同时注意不要随意去动摆设的样品，以防意外损坏。",
    "5、行程结束后30日内，甲方可以提供开票信息给乙方，乙方将按照实际提供的服务内容、适用税率、合同金额（不包含代收代付的旅游费用）开具电子普通发票给甲方。",
    "6、甲方委托乙方代收并代付给第三方的旅游费用，由实际收款的第三方开具发票给甲方，乙方不承担开票义务。"
  ],
  "湘西": [
    " 1、湘西气候独特，山区湿润多雨多雾，峡谷平坝日照较强，气候变化较快。建议携带方便合适衣物方便随时添减，防水防滑适合步行鞋类，必备晴雨伞。",
    "2、部分山区住宿条件有限，建议自备全部个人用品，洗衣不易干，准备足够衣物。",
    "3、湘西山区较多，山路坡度弯度较大，有晕车历史的同学请提前准备晕车药或晕车贴，早餐尽量清淡不易过饱。",
    "4、湘西地区饮食独特，部分少数民族有生食鱼肉的习惯，餐饮中有很多独有野生佐料，用餐时请一定问清楚，谨慎尝试。苗族土家族有以酒迎客习俗，自制白酒后劲大，一定要注意。",
    "5、请自备适当常用药物，如感冒药、肠胃药、驱蚊药水等。部分区域蚊虫较多，毒性较大要注意。",
    "6、户外考察期间，山野河流要注意安全，不可下河游泳，不得前往景区未开发区域探险游览。遇到野生动物不要惊慌，注意结伴而行。",
    "7、住宿客栈或酒店时，入住后请先检查房间，有卫生问题尽快告知导游，方便尽快解决。部分区域住宿条件有限，如遇房型不一，分开多家住宿有差异，将随机安排敬请谅解。",
    "8、景区购物注意问清价格，货比三家，谨慎购买。部分景区内有单独收费小景点，自行前往时可携带学生证购买优惠票。",
    "9、行程结束后30日内，甲方可以提供开票信息给乙方，乙方将按照实际提供的服务内容、适用税率、合同金额（不包含代收代付的旅游费用）开具电子普通发票给甲方。",
    "10、甲方委托乙方代收并代付给第三方的旅游费用，由实际收款的第三方开具发票给甲方，乙方不承担开票义务。"
  ],
  "新疆": [
    "1、新疆虽使用北京时间，但与内地有2小时的时差，夏季天黑一般在22：00左右，相应的作息时间也比内地推后两小时，须自我调整。特别是起床及用餐时间。少数民族使用“新疆时间”，请注意区别",
    "2、新疆属于大陆性干旱气候，昼夜温差大, 不同季节、不同海拔区域气候差异显著。如遇恶劣天气，气温乍暖乍寒，请注意及时增减衣服，做好预寒及防暑工作。建议：自备薄、厚外套，早晚温差大，尤其是塔县，塔县属于高原高海拔地区，请随时备用一件厚外套",
    "3、证件必备：身份证原件、护照原件（外籍学生）、学生证原件",
    "4、新疆考察线路长、考察点分散、乘车时间较长，舟车劳顿且受自然条件的限制，考察点及沿途餐厅的条件与经济发达地区相比较落后，无论从硬件设施或饭菜质量都有一定的差距，请见谅",
    "5、西北人嗜辣，吃羊肉，且那里水质较硬，建议自备常用药如黄连素、泻立停、藿香正气水及感冒发烧药品等",
    "6、考察全程请服从领队老师的安排，牢记领队老师告之的安全事项，新疆属于少数民族聚居地区，各少数民族有其独特的宗教信仰。随行领队老师会讲解关于民族习俗禁忌问题，请注意尊重少数民族风俗习惯，避名谈及宗教信仰及政治问题，以免造成不必要的误会",
    "7、重要提醒：患有心脏病、高血压、重症感冒、心肌梗塞、中风等重大疾病者以及半年内腰椎做过手术的人群，建议不参加此考察线路行程，如有隐瞒且因自身健康原因造成的损失，由出行人自行负责",
    "8、特别说明:若考察日程中需前往塔县，塔什库尔干县城平均海拔在4000m以上，部分人群可能会出现高反，建议在前往塔县之前的地方（喀什县城）自行提前购买氧气补给装备（如氧气瓶），适当食用碳水化合物、水果或补充维生素C，少吃油腻的食物，也不宜吃太饱",
    "9、新疆是水果之乡，到新疆吃水果是一大乐事，食用前一定注意清洁，以免引起腹泻。哈密瓜为热性水果，应适量食用，以免上火。不可一下子吃太多，也不要在吃完水果后再喝热茶，以免造成身体不适",
    "10、考察调研时最好穿平底鞋，以免扭伤。要做到“走路不看景，看景不走路”。爱护文物古迹，保护环境。旅游者每到一地都应自觉爱护当地的文物古迹和景区的自然环境",
    "11、行程结束后30日内，甲方可以提供开票信息给乙方，乙方将按照实际提供的服务内容、适用税率、合同金额（不包含代收代付的旅游费用）开具电子普通发票给甲方。",
    "12、甲方委托乙方代收并代付给第三方的旅游费用，由实际收款的第三方开具发票给甲方，乙方不承担开票义务。"
  ],
  "山东": [
    "1、景区全部为实名制刷身份证进入，身份证和学生证务必每天随身携带！部分遗址类场馆禁止闪光灯拍摄，参观时勿触碰文物展品",
    "2、山东属温带季风气候，昼夜温差明显，建议携带防风外套；夏季日照强烈，备好防晒装备及雨具应对多变天气",
    "3、行程以大巴接送为主，部分乡村考察点道路狭窄，晕车同学提前备好药品；下车时清点随身物品，勿遗漏车内",
    "4、鲁菜口味偏重咸鲜，部分地区喜食大葱、大蒜等佐料；沿海城市海鲜丰富，食用时注意搭配，避免肠胃不适",
    "5、参访齐鲁文化遗址、儒家学府时，着装宜端庄得体",
    "6、企业考察时，请大家珍惜进入公司考察学习机会，遵守公司规定，室内场合保持安静，做到有礼有节",
    "7、济南、青岛等城市地铁网络发达，自由活动时可下载「济南地铁」「青岛地铁」APP扫码乘车;晚高峰时段打车较紧张，建议提前规划行程",
    "8、台儿庄古城、青州古城等水乡区域石板路湿滑，雨天慢行防滑;禁止在护城河垂钓、游泳，夜间结伴出行不独行",
    "9、晚间外出需2人以上结伴并报备带队老师；不前往与考察学习无关的娱乐场所",
    "10、行程结束后30日内，甲方可以提供开票信息给乙方，乙方将按照实际提供的服务内容、适用税率、合同金额（不包含代收代付的旅游费用）开具电子普通发票给甲方",
    "11、甲方委托乙方代收并代付给第三方的旅游费用，由实际收款的第三方开具发票给甲方，乙方不承担开票义务"
  ],
  "安徽": [
    "1、景区全部为实名制刷身份证进入，身份证和学生证务必每天随身携带！部分遗址类场馆禁止闪光灯拍摄，参观时勿触碰文物展品",
    "2、安徽兼具亚热带与温带季风气候，夏季湿热多雨，备好防晒用品与雨具；冬季湿冷，需携带保暖衣物",
    "3、行程以大巴为主，山路蜿蜒，晕车同学备好药品，乘车系好安全带；下车时清点随身物品，勿遗漏车内",
    "4、徽菜重油、重色、重火功，臭鳜鱼、李鸿章大杂烩等风味独特。沿江地区河鲜丰富，食用海鲜、河鲜注意搭配食醋、生姜，避免肠胃不适。景区餐饮价格偏高，选择正规店铺就餐，保证饮食卫生",
    "5、在古镇写生时，爱护古建筑与环境，不乱涂乱画、乱扔垃圾。河边石板路湿滑，严禁下河游泳、捕鱼，夜间不独自前往偏僻区域",
    "6、企业考察时，请大家珍惜进入公司考察学习机会，遵守公司规定，室内场合保持安静，做到有礼有节",
    "7、合肥、芜湖等城市地铁便捷，可下载“合肥轨道”等APP乘车",
    "8、晚间外出需2人以上结伴并报备带队老师；不前往与考察学习无关的娱乐场所",
    "9、行程结束后30日内，甲方可以提供开票信息给乙方，乙方将按照实际提供的服务内容、适用税率、合同金额（不包含代收代付的旅游费用）开具电子普通发票给甲方",
    "10、甲方委托乙方代收并代付给第三方的旅游费用，由实际收款的第三方开具发票给甲方，乙方不承担开票义务"
  ],
  "通用": [
    "1、摄影时，请注意安全，不要到有危险的地区拍摄或攀爬",
    "2、 导游全程不引导购物，如遇导游引导购物请立即向花儿举报；大家自行选购旅游纪念商品、当地土特产时，请注意货比三家；同时注意不要随意去动摆设的样品，以防意外损坏",
    "3、 行程结束后30日内，甲方可以提供开票信息给乙方，乙方将按照实际提供的服务内容、适用税率、合同金额（不包含代收代付的旅游费用）开具电子普通发票给甲方。",
    "4、甲方委托乙方代收并代付给第三方的旅游费用，由实际收款的第三方开具发票给甲方，乙方不承担开票义务。"
  ]
};
